function adminWalletManagement() {
  let walletManagement = [
    {
      name: "Wallet Management",
      icon: "Wallet-management",
      logoName: "MyAccounts",
      // flag: "voucherRequired",
      displayService: "adminWalletManagement",
      items: [],
    },
  ];

  const dashboard = () => {
    const dashboardArr = [
      {
        path: "/index/AdminWallet-Management",
        name: "Dashboard",
        icon: "dashboard",
        logoName: "dashboard",
        flag: "DASHBOARD",
      },
    ];

    return dashboardArr;
  };

  const walletManagementSub = () => {
    const profileArr = [
      {
        path: "/index/WalletTransaction",
        name: "Transactions",
        icon: "WalletManagement",
        logoName: "wallet transaction",
        flag:"TRANSACTIONS"
        // flag: "isProfileSetting",
      },
    ];

    // if (
    //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
    // ) {
    return profileArr;
    // } else {
    //   return "";
    // }
  };
  const admin_Configuration = () => {
    const profileConfiguration = [
      {
        path: "/index/AdminConfiguration",
        name: "Configuration",
        icon: "Configration",
        logoName: "kyc configration1",
        flag:"CONFIGURATION"
        // flag: "isProfileSetting",
      },
    ];

    return profileConfiguration;

  };

  // const AdminRefund = () => {
  //   const RefundArr = [
  //     {
  //       path: "/index/AdminRefund",
  //       name: "Refund",
  //       icon: "WalletManagement",
  //       logoName: "wallet transaction",
  //       // flag: "isProfileSetting",
  //     },
  //   ];
  //   return RefundArr;
  // };

  let a = dashboard();
  let b = walletManagementSub();
  let c = admin_Configuration();
  // let c = AdminRefund();

  walletManagement[0].items = [...a, ...b, ...c];

  return walletManagement;
}

export default adminWalletManagement;
